import React from "react";
import "../../Styles/Taetigkeitsbericht/taetigkeitsbericht.css";
import {Button, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import jsPDF from "jspdf";
import moment from "moment";
import {faFilePdf} from "@fortawesome/free-regular-svg-icons";

const AppWebReportTaetigkeitsberichtActionButtonsComponent = (props) => {
    const [saveData, setSaveData] = React.useState(props.taetigkeitsberichtData);


    React.useEffect(() => {
        setSaveData(props.taetigkeitsberichtData);
    }, [props.taetigkeitsberichtData]);


    function handleExportClick() {
        let res = createTReport({
            type: "downloadPDF",
            anschrift: ""
        });
        console.log(res)
    }

    function addTEmployee(doc) {

        let reportData = saveData;
        let coworkers = reportData.coworkers;

        if (coworkers.length === 0) {
            emptyTable(doc, doc.lastAutoTable.finalY + 12)
        } else {

            let employeeHead = [];
            employeeHead.push("Vorname");
            employeeHead.push("Nachname");
            employeeHead.push("Rolle");
            employeeHead.push("Arbeitszeit");

            let employeeBody = [];
            coworkers.forEach((employee) => {
                let employeeInfo = Object.values(employee).slice(1, 4);
                let workHours = employee.workHours.startTime.substring(0, 5) + " - " + employee.workHours.endTime.substring(0, 5);
                employeeInfo.push(workHours);
                employeeBody.push(employeeInfo);
            });

            doc.autoTable({
                margin: 25,
                startY: doc.lastAutoTable.finalY + 12,
                theme: 'grid',
                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
                head: [employeeHead],
                body: employeeBody
            });
        }
    }

    function addAGTable(doc) {

        let reportData = saveData;
        let AGData = reportData.auftraggeber;

        if (AGData.length === 0) {
            emptyTable(doc, doc.lastAutoTable.finalY + 12,)
        } else {

            let AGHead = [];
            AGHead.push("Vorname");
            AGHead.push("Nachname");

            let AGBody = [];
            AGData.forEach((AG) => {
                let AGInfo = Object.values(AG).slice(1, 3);
                AGBody.push(AGInfo);
            });


            doc.autoTable({
                margin: 25,
                startY: doc.lastAutoTable.finalY + 12,
                theme: 'grid',

                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
                head: [AGHead],
                body: AGBody
            });

        }
    }

    function emptyTable(doc, y) {
        doc.autoTable({
            margin: 25,
            startY: y,
            headStyles: {
                cellHeight: "auto",
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0],
            },
            head: [['-']],
            body: [],
        });
    }

    function addMaterialTable(doc) {

        let reportData = saveData;
        let materialData = reportData.material;
        if (materialData.length === 0) {
            emptyTable(doc, 32)
        } else {
            let columns = [
                {title: "Position", dataKey: "Position"},
                {title: "Bezeichnung", dataKey: "Bezeichnung"},
                {title: "Anzahl", dataKey: "Anzahl"},
                {title: "Teilaufmaß", dataKey: "Teilaufmas"},
                {title: "Einheit", dataKey: "Einheit"}
            ];
            let rows = [];
            materialData.forEach((material) => {
                let materialInfo = {}
                materialInfo.Position = material.position
                materialInfo.Bezeichnung = material.description
                if (material.unit === "㎡" || material.unit === "m²") {
                    materialInfo.Einheit = "m²"
                } else if (material.unit === "㎥" || material.unit === "m³") {
                    materialInfo.Einheit = "m³"
                } else {
                    materialInfo.Einheit = material.unit
                }
                materialInfo.Anzahl = material.menge
                materialInfo.Teilaufmas = material.aufmas
                rows.push(materialInfo);
            });
            doc.autoTable(columns, rows, {
                margin: 25,
                startY: 32,
                theme: 'grid',
                showHeader: 'everyPage',
                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                style: {overflowColumns: 'linebreak'},
                // Override the default above for the text column
                columnStyles: {
                    Teilmas: {overflow: 'linebreak'},
                    Position: {overflow: 'ellipsize', cellWidth: 'wrap'},
                    Einheit: {overflow: 'ellipsize', cellWidth: 15},
                    Anzahl: {overflow: 'ellipsize', cellWidth: 15},
                    Bezeichnung: {overflowColumns: 'linebreak', cellWidth: 30}
                },
                didParseCell: function (hookData) {
                    if (

                        (hookData.section === "body" && hookData.column.dataKey === "Bezeichnung")
                    ) {
                        hookData.cell.styles.minCellHeight = hookData.cell.text.length * 12
                    }
                },
            })
        }
    }

    function addDevicesTable(doc) {

        let reportData = saveData;
        let deviceData = reportData.device;
        if (deviceData.length === 0) {
            emptyTable(doc, doc.lastAutoTable.finalY + 12)
        } else {
            let deviceHead = [];
            deviceHead.push("Name");

            let deviceBody = [];
            deviceData.forEach((device) => {
                let deviceInfo = Object.values(device).slice(1, 2);
                deviceBody.push(deviceInfo);
            });

            doc.autoTable({
                margin: 25,
                startY: doc.lastAutoTable.finalY + 12,
                theme: 'grid',

                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
                head: [deviceHead],
                body: deviceBody
            });
        }
    }

    async function getTaetigkeitenCDNImages(taetigkeitenData) {

        let retrievedImagesInner = [];

        if (taetigkeitenData !== undefined) {
            await Promise.all(taetigkeitenData?.map(async (item) => {
                await Promise.all(item.pictures.map(async (itemInner) => {
                    const response = await getSignedUrl(itemInner)

                    const data = await response.json();
                    data.description = item.description
                    retrievedImagesInner.push(data);
                }));
                return retrievedImagesInner;
            }));
        }
        // return theCDNImages
        let imagesList = await modifydataforimage(retrievedImagesInner)
        return imagesList

    }

    async function getCDNImages(verortungData) {

        let theCDNImages = [];
        let theCDNImagesURLs = []

        if (verortungData !== undefined) {


            theCDNImages = await Promise.all(verortungData?.map(async (item) => {


                const response = await getSignedUrl(item)
                let d = await response.json()

                return d

            }));

            theCDNImages.forEach((item) => {
                let singleImage = {}
                singleImage.url = item.url
                singleImage.description = "Verortung"
                theCDNImagesURLs.push(singleImage)
            })

        }

        let images = await modifydataforimage(theCDNImagesURLs)
        //return theCDNImagesURLs
        return images
    }

    function getImageDimensions(url) {
        return new Promise((resolve, reject) => {
            // Create a new Image object
            const img = new Image();

            // Set the image source to the provided URL
            img.src = url;

            // Define the callback function to be executed when the image is loaded
            img.onload = function () {
                // Resolve the promise with the image dimensions
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            };

            // Handle errors in case the image fails to load
            img.onerror = function (error) {
                // Reject the promise with an error object
                reject({
                    error: "Failed to load image",
                    details: error
                });
            };
        });
    }


    async function modifydataforimage(theCDNImagesURLs) {
        let images = await Promise.all(
            theCDNImagesURLs.map(async (image) => {
                try {
                    const dimensions = await getImageDimensions(image.url);
                    return {
                        link: image.url,
                        description: image.description,
                        ...dimensions
                    };
                } catch (error) {
                    return {
                        error
                    };
                }
            })
        );
        return images
    }

    async function retrieveVerortungImages(i) {
        let reportData = i
        let verortungData = reportData.verortung;
        return await getCDNImages(verortungData);
    }

    async function addVerortungImages(doc, i) {

        await retrieveVerortungImages(i).then(images => {
            printImages(doc, "Verortungen der Tätigkeit(en)", images)
        })
    }


    function printImages(doc, mainDesc, images) {
        if (mainDesc !== "Tätigkeiten") {
            for (let i = 0; i < images.length; i++) {
                let x = 25
                let y = 40
                let MAX_WIDTH = 180;
                let MAX_HEIGHT = 280
                doc.addPage();
                doc.setFontSize(18);
                doc.text(mainDesc, 25, 30);
                if (mainDesc === "Tätigkeiten") {
                    doc.setFontSize(16);
                    doc.text("Beschreibung der Tätigkeit(en):", 25, 45, "left")
                    doc.text(images[i].description, 25, 55, {maxWidth: 160})
                    doc.addPage();
                    doc.setFontSize(18);
                    doc.text("Bild(er) der Taetigkeit(en)", 25, 30);
                }
                let width = images[i].width;
                let height = images[i].height;
                MAX_WIDTH = 170;
                MAX_HEIGHT = 240

                if (width > height) {
                    MAX_HEIGHT = 170;
                    MAX_WIDTH = 240

                    height = height * (MAX_WIDTH / width);
                    width = MAX_WIDTH;
                } else {
                    if (height > MAX_HEIGHT & height > width) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                let deg = null
                if (images[i].width > images[i].height) {
                    y = y + MAX_WIDTH - height
                    x = x + MAX_HEIGHT
                    deg = 90
                }
                doc.addImage(images[i].link, 'PNG', x, y, width, height, undefined, 'FAST', deg);

            }
        }

        if (mainDesc === "Tätigkeiten") {
            let headline = false
            let imagesGroup = Object.groupBy(images, e => [e.description]);
            for (const key in imagesGroup) {
                let group = imagesGroup[key]
                for (let i = 0; i < group.length; i++) {
                    let x = 25
                    let y = 40
                    let MAX_WIDTH = 180;
                    let MAX_HEIGHT = 280
                    doc.addPage();
                    doc.setFontSize(18);
                    if (headline) {
                        doc.text("Bild(er) der Taetigkeit(en)", 25, 30)
                    }

                    if (mainDesc === "Tätigkeiten") {
                        if (i === 0) {
                            headline = true
                            doc.setFontSize(16);
                            doc.text("Beschreibung der Tätigkeit(en):", 25, 30, "left")
                            doc.text(group[i].description, 25, 45, {maxWidth: 160})
                            doc.addPage();
                            doc.text("Bild(er) der Taetigkeit(en)", 25, 30);
                        }

                    }
                    let width = group[i].width;
                    let height = group[i].height;
                    MAX_WIDTH = 170;
                    MAX_HEIGHT = 240

                    if (width > height) {
                        MAX_HEIGHT = 170;
                        MAX_WIDTH = 240

                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    } else {
                        if (height > MAX_HEIGHT & height > width) {
                            width = width * (MAX_HEIGHT / height);
                            height = MAX_HEIGHT;
                        }
                    }
                    let deg = null
                    if (group[i].width > group[i].height) {
                        y = y + MAX_WIDTH - height
                        x = x + MAX_HEIGHT
                        deg = 90
                    }
                    doc.addImage(group[i].link, 'PNG', x, y, width, height, undefined, 'FAST', deg);
                }
            }
        }
    }


    async function addTaetigkeitenData(doc, i) {


        let taetigkeitenData = [i]

        let imagesOutArray = await getTaetigkeitenCDNImages(taetigkeitenData)

        let descriptions = [];
        taetigkeitenData.forEach((taetigkeit) => {
            let description = taetigkeit.description;
            descriptions.push(description);
        });
        printImages(doc, "Tätigkeiten", imagesOutArray)


    }

    async function addSignature(doc,) {
        let signImg = {}
        signImg.url = saveData.creatorSignature
        let response = await getSignedUrl(signImg)
        response = await response.json()
        doc.addImage(response.url, 'PNG', 25, doc.lastAutoTable.finalY + 18, 50, 30, undefined, 'FAST');
    }

    async function getSignedUrl(itemInner) {
        return await fetch(
            "https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/getpresignedurl",
            {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({"data": {"object_path": itemInner.url}}),
            })
    }

    async function createTReport(reportDetails) {
        let projectName=saveData.metaAndProjectData.projectData.projectName
        const doc = new jsPDF({orientation: "p", lineHeight: 1.5}, "", "", true);
        let s = 0

        doc.setFont("Calibri", "normal", "");
        doc.setFontSize(24)
        doc.text("Tätigkeitbericht", 25, 30, "left",);
        const taetigkeitTextWidth = doc.getTextWidth("Tätigkeitbericht");
        doc.line(25, 31, 25 + taetigkeitTextWidth, 31)
        if (reportDetails.type === "post") {
            s=40
            doc.setFont("Calibri", "normal", "");
            doc.setFontSize(13.5)
            doc.text("Empfänger:", 25, 10+s, "left",);
            const empfangerTextWidth = doc.getTextWidth("Empfänger:");
            doc.line(25, 11+s, 25 + empfangerTextWidth, 11+s)
            doc.setFontSize(12)
            doc.text(reportDetails.anschrift, 25, 16+s, "left",);
            //doc.addPage()
        }

        doc.setFontSize(16);
        doc.text("Projekt: " + projectName, 25, 58 + s, "left",);
        doc.text("Datum: " + moment().format("DD.MM.YYYY"), 25, 72 + s, "left");

        doc.text("Ersteller: " + saveData.metaAndProjectData.metaData.creatorFirstName + " " + saveData.metaAndProjectData.metaData.creatorLastName, 25, 140 + s, "left");
        doc.text("Status: " + "Akkzeptiert", 25, 150 + s, "left");
        let iwetter = saveData.wetter.innenWetter
        let awetter = saveData.wetter.aussenWetter
        if (iwetter === "") {
            iwetter = "- "
        }
        if (awetter === "") {
            awetter = "- "
        }
        doc.text("Innen-Temperatur: " + iwetter + "°C", 25, 170 + s, "left");
        doc.text("Außen-Temperatur: " + awetter + "°C", 25, 180 + s, "left");
        doc.text("Details: " + saveData.wetter.details, 25, 190 + s, "left");


        //add images//
        for (let i in saveData.taetigkeiten) {
            await addVerortungImages(doc, saveData.taetigkeiten[i]);
            await addTaetigkeitenData(doc, saveData.taetigkeiten[i]);
        }


        doc.addPage();
        doc.setFontSize(16);
        //doc.setTextColor(0, 76, 153)
        doc.text("Material", 25, 30, "left");
        addMaterialTable(doc);
        doc.text("Betriebsmittel", 25, doc.lastAutoTable.finalY + 10, "left");
        addDevicesTable(doc);
        doc.text("Arbeitszeiten", 25, doc.lastAutoTable.finalY + 10, "left");
        addTEmployee(doc);
        doc.text("Auftraggeber", 25, doc.lastAutoTable.finalY + 10, "left");
        addAGTable(doc);

        doc.text("Unterschrift Ersteller", 25, doc.lastAutoTable.finalY + 15, "left");
        await addSignature(doc);
        doc.setFontSize(15);
        doc.text(saveData.metaAndProjectData.metaData.creatorFirstName + "," + saveData.metaAndProjectData.metaData.creatorLastName, 25, doc.lastAutoTable.finalY + 65, "left");


        for (let i = 1; i <= doc.getNumberOfPages(); i++) {
            doc.setPage(i);
            doc.setFontSize(10);
//            doc.text(25, doc.internal.pageSize.height - 10, "Täetigkeitbericht: " + new Date().toLocaleDateString() + ", " + projectName);
            doc.text(25, doc.internal.pageSize.height - 10, moment().format("YYYYMMDD") + "_TÄR_" + projectName);
            doc.text(doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10, "Seite: " + i.toString() + " von " + doc.getNumberOfPages().toString());
        }
        let pdfname = moment().format("YYYYMMDD") + "_TÄR_" + projectName

        if (reportDetails.type === "downloadPDF") {
            doc.save(pdfname + ".pdf")
            return {status: "200"}
        } else {
            doc.save(pdfname + ".pdf")
            return {
                status: "200",
                pdf: doc.output("datauristring"),
                pdfName: pdfname,
                savePdf: doc.output("datauristring")
            }
        }
    }



    return (
        <Row className="justify-content-between">
            <Col className="ml-4">
            </Col>


            <Col className="ml-4" style={{textAlign: "center"}}>

            </Col>

            <Col className="text-right mr-5">
                <Button
                    title="Export"
                    className="handwai-btn-create mr-4"
                    onClick={handleExportClick}
                >
                    <FontAwesomeIcon icon={faFilePdf}/>
                </Button>
            </Col>


        </Row>
    );

}


export default AppWebReportTaetigkeitsberichtActionButtonsComponent;
